import { getPage } from '@bepro-travel/fe.shared';
import { useContext, useEffect } from 'react';
import { MainContext } from '../context/MainContext.ts';

export const useGetPage = (url: string) => {
  const { setHeader, setFooter, setSiteConfig } = useContext(MainContext);

  useEffect(() => {
    (async () => {
      const page = await getPage(url);

      if (page) {
        setHeader(page.pageHeader);
        setFooter(page.pageFooter);
        setSiteConfig(page.siteConfig);
      }
    })();
  }, []); // eslint-disable-line
};
